import Vue from 'vue';
import { store } from "../../../../store/store-init.js";

// FILTERS GLOBALES
let msisdnToPhone = (msisdn) => {
    msisdn += ""; // TURNS IT INTO A STRING
    let regExp = /(\d{3})(\d{3})(\d{4})$/;
    let conform = msisdn.match(regExp)
    return '(' + conform[1] + ') ' + conform[2] + '-' + conform[3];
}

Vue.filter('msisdnToPhone', msisdnToPhone);

let mb2gb = mbNumber => {
    return ( mbNumber / 1024 ).toFixed(2) + ' GB'
}

Vue.filter('mb2gb', mb2gb);

let estatusReName = (status) => {
    const trimmed = status.trim().toLowerCase();
    return trimmed === 'nuevo' ? 'Pedido en preparación...' : status.trim();
}

Vue.filter('estatusReName', estatusReName);

let staticTitulo = (hash) => {
    const catalog = store.getters.catalogStaticContent;
    if(!catalog.length) return '';
    const item = catalog.find(content => content.hash === hash);
    return item ? item.title : (hash + '-titulo');
}

Vue.filter('staticTitulo', staticTitulo);
Vue.filter('staticTitle', staticTitulo);

let staticContent = (hash) => {
    const catalog = store.getters.catalogStaticContent;
    if(!catalog.length) return '';
    const item = catalog.find(content => content.hash === hash);
    return item ? item.content : (hash + '-content');
}

Vue.filter('staticContent', staticContent);
Vue.filter('staticContenido', staticContent);

let staticContentAlt = (hash) => {
    const catalog = store.getters.catalogStaticContent;
    if(!catalog.length) return '';
    const item = catalog.find(content => content.hash === hash);
    return item ? item.content_alt : (hash + '-content-alt');
}

Vue.filter('staticContentAlt', staticContentAlt);
Vue.filter('staticContenidoAlt', staticContentAlt);



export {
    msisdnToPhone, 
    estatusReName,
    mb2gb,
    staticTitulo
}